import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { ThemesList, CreateTheme, UpdateTheme } from "./pages";

export const ThemesRouter = [
  <Route
    path="/themes"
    element={
      <ProtectedRoute roles={["Any"]}>
        <ThemesList />
      </ProtectedRoute>
    }
  />,

  <Route path="/theme">
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreateTheme />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdateTheme />
        </ProtectedRoute>
      }
    />
  </Route>,
];
